import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import VenueList from './pages/VenueList';
import VenueForm from './pages/VenueForm';
import CourtManagement from './pages/CourtManagement';
import AvailabilityCalendar from './pages/AvailabilityCalendar';
import PricingManagement from './pages/PricingManagement';
import ManualBooking from './pages/ManualBooking';
import AllBookings from './pages/AllBookings';
import VenueBookings from './pages/VenueBookings';
import BookingDetail from './pages/BookingDetail';
import Reports from './pages/Reports';
import ActivityReportPage from './pages/ActivityReportPage';
import BookingDetailsReport from './pages/BookingDetailsReport';
import Payouts from './pages/Payouts';
import Settings from './pages/Settings';
import OpenPlays from './pages/OpenPlays';
import CreateOpenPlay from './pages/CreateOpenPlay';
import EditOpenPlay from './pages/EditOpenPlay';
import OpenPlayDetail from './pages/OpenPlayDetail';
import SelectVenueOwner from './pages/SelectVenueOwner';
import UserManagement from './pages/UserManagement';
import Crm from './pages/Crm';

function OpenPlayAccess({ children }) {
  return <ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager', 'OpenPlayOrganiser']}>{children}</ProtectedRoute>;
}

function OwnerOnly({ children }) {
  return <ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager']}>{children}</ProtectedRoute>;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '8px',
            background: '#333',
            color: '#fff',
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/select-owner"
          element={
            <ProtectedRoute allowedRoles={['Admin']}>
              <SelectVenueOwner />
            </ProtectedRoute>
          }
        />
        <Route
          element={
            <ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager', 'BookingStaff', 'OpenPlayOrganiser']}>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<OwnerOnly><Dashboard /></OwnerOnly>} />
          <Route path="/venues" element={<OwnerOnly><VenueList /></OwnerOnly>} />
          <Route path="/venues/new" element={<ProtectedRoute allowedRoles={['CourtOwner']}><VenueForm /></ProtectedRoute>} />
          <Route path="/venues/:id" element={<OwnerOnly><VenueForm /></OwnerOnly>} />
          <Route path="/venues/:id/courts" element={<OwnerOnly><CourtManagement /></OwnerOnly>} />
          <Route
            path="/venues/:id/availability"
            element={<OwnerOnly><AvailabilityCalendar /></OwnerOnly>}
          />
          <Route path="/venues/:id/pricing" element={<OwnerOnly><PricingManagement /></OwnerOnly>} />
          <Route path="/venues/:id/bookings" element={<OwnerOnly><VenueBookings /></OwnerOnly>} />
          <Route path="/bookings" element={<ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager', 'BookingStaff']}><AllBookings /></ProtectedRoute>} />
          <Route path="/bookings/manual" element={<ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager', 'BookingStaff']}><ManualBooking /></ProtectedRoute>} />
          <Route path="/bookings/:id" element={<ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager', 'BookingStaff']}><BookingDetail /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute allowedRoles={['CourtOwner']}><UserManagement /></ProtectedRoute>} />
          <Route path="/crm" element={<ProtectedRoute allowedRoles={['CourtOwner']}><Crm /></ProtectedRoute>} />
          <Route path="/reports" element={<OwnerOnly><Reports /></OwnerOnly>} />
          <Route path="/reports/revenue-by-activity" element={<OwnerOnly><ActivityReportPage key="revenue" mode="revenue" /></OwnerOnly>} />
          <Route path="/reports/payment-transactions" element={<OwnerOnly><ActivityReportPage key="transactions" mode="transactions" /></OwnerOnly>} />
          <Route path="/reports/booking-details" element={<OwnerOnly><BookingDetailsReport /></OwnerOnly>} />
          <Route path="/payouts" element={<ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager']}><Payouts /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute allowedRoles={['CourtOwner', 'VenueManager']}><Settings /></ProtectedRoute>} />
          <Route path="/step-dance" element={<OpenPlayAccess><OpenPlays key="StepDance" activityType="StepDance" /></OpenPlayAccess>} />
          <Route path="/step-dance/new" element={<OpenPlayAccess><CreateOpenPlay key="StepDance" activityType="StepDance" /></OpenPlayAccess>} />
          <Route path="/step-dance/:id/edit" element={<OpenPlayAccess><EditOpenPlay activityType="StepDance" /></OpenPlayAccess>} />
          <Route path="/step-dance/:id" element={<OpenPlayAccess><OpenPlayDetail /></OpenPlayAccess>} />
          <Route path="/openplays" element={<OpenPlayAccess><OpenPlays key="OpenPlay" activityType="OpenPlay" /></OpenPlayAccess>} />
          <Route path="/openplays/new" element={<OpenPlayAccess><CreateOpenPlay key="OpenPlay" activityType="OpenPlay" /></OpenPlayAccess>} />
          <Route path="/openplays/:id/edit" element={<OpenPlayAccess><EditOpenPlay /></OpenPlayAccess>} />
          <Route path="/openplays/:id" element={<OpenPlayAccess><OpenPlayDetail /></OpenPlayAccess>} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}
